(function () {
  'use strict';

  // ── Selectors (confirmed from your HTML/Liquid) ────────────────────────────
  const NEXT_LINK_SELECTOR    = 'a[rel="next"]';
  const NAV_SELECTOR          = '.pagination__nav';
  const PRODUCT_LIST_SELECTOR = '.product-facet__product-list';
  const INNER_SELECTOR        = '.product-list__inner';
  const SCROLL_OFFSET         = '600px'; // Itna pehle se loading start ho jaye ke user ko wait na karna pade

  let isLoading = false;
  let observer  = null;

  // ── CSS inject ───────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('focal-inf-styles')) return;
    const s = document.createElement('style');
    s.id = 'focal-inf-styles';
    s.textContent = `
      @keyframes focal-spin {
        to { transform: rotate(360deg); }
      }
      @keyframes focal-fade-in {
        from { opacity: 0; transform: translateY(18px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      #focal-inf-loader {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 36px 0 20px;
        grid-column: 1 / -1;
      }
      #focal-inf-loader svg {
        animation: focal-spin 0.75s linear infinite;
      }
      .pagination__nav {
        display: none !important;
      }
      .focal-new-item {
        animation: focal-fade-in 0.45s ease forwards;
      }
    `;
    document.head.appendChild(s);
  }

  // ── Spinner ──────────────────────────────────────────────────────────────
  function showLoader() {
    if (document.getElementById('focal-inf-loader')) return;
    const loader = document.createElement('div');
    loader.id = 'focal-inf-loader';
    loader.innerHTML = `
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="15" stroke="currentColor" stroke-width="2.5" stroke-opacity="0.15"/>
        <path d="M18 3 a15 15 0 0 1 15 15" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
      </svg>`;

    const inner = document.querySelector(INNER_SELECTOR);
    if (inner) {
      inner.insertAdjacentElement('afterend', loader);
    } else {
      const productList = document.querySelector(PRODUCT_LIST_SELECTOR);
      if (productList) productList.after(loader);
    }
  }

  function hideLoader() {
    const loader = document.getElementById('focal-inf-loader');
    if (loader) loader.remove();
  }

  // ── Helpers ──────────────────────────────────────────────────────────────
  function getNextLink() {
    return document.querySelector(NEXT_LINK_SELECTOR);
  }

  // ── Animate newly added nodes ───────────────────────────────────────────
  function animateItems(nodes) {
    nodes.forEach((item, i) => {
      item.classList.add('focal-new-item');
      item.style.animationDelay = `${i * 40}ms`;
      item.addEventListener('animationend', () => {
        item.classList.remove('focal-new-item');
        item.style.animationDelay = '';
      }, { once: true });
    });
  }

  // ── Sentinel attach ─────────────────────────────────────────────────────
  function attachSentinel() {
    const old = document.getElementById('focal-inf-sentinel');
    if (old) old.remove();

    if (!getNextLink()) { cleanup(); return; }

    const sentinel = document.createElement('div');
    sentinel.id = 'focal-inf-sentinel';
    sentinel.style.cssText = 'height:1px;width:100%;pointer-events:none;';

    const inner = document.querySelector(INNER_SELECTOR);
    const productList = document.querySelector(PRODUCT_LIST_SELECTOR);
    if (inner) {
      inner.insertAdjacentElement('afterend', sentinel);
    } else if (productList) {
      productList.after(sentinel);
    }

    observer.observe(sentinel);
  }

  // ── Core: fetch next page HTML, parse, APPEND only new products ──────────
  async function loadNext() {
    if (isLoading) return;
    const nextLink = getNextLink();
    if (!nextLink) { cleanup(); return; }

    isLoading = true;
    showLoader();

    try {
      const res = await fetch(nextLink.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Naye page se sirf product items nikalo, poora HTML nahi
      const newInner = doc.querySelector(INNER_SELECTOR);
      const currentInner = document.querySelector(INNER_SELECTOR);

      if (newInner && currentInner) {
        const newItems = Array.from(newInner.children);
        const frag = document.createDocumentFragment();
        newItems.forEach((node) => frag.appendChild(node));

        hideLoader();
        currentInner.appendChild(frag);   // ✅ Purane products intact rehte hain, naye end mein add hote hain
        animateItems(newItems);
      } else {
        hideLoader();
      }

      // Naye page ka pagination nav le ke current next-link update karo
      const newNav = doc.querySelector(NAV_SELECTOR);
      const currentNav = document.querySelector(NAV_SELECTOR);
      if (newNav && currentNav) {
        currentNav.outerHTML = newNav.outerHTML; // rel="next" updated ho jayega ya gayab (last page)
      }

    } catch (err) {
      console.error('Focal infinite scroll error:', err);
      hideLoader();
    } finally {
      isLoading = false;
      attachSentinel(); // Updated next-link ke mutabiq sentinel reattach/remove
    }
  }

  // ── Full cleanup (last page reached) ───────────────────────────────────
  function cleanup() {
    if (observer) { observer.disconnect(); observer = null; }
    const sentinel = document.getElementById('focal-inf-sentinel');
    if (sentinel) sentinel.remove();
    hideLoader();
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    if (!document.querySelector(PRODUCT_LIST_SELECTOR)) return;
    if (!getNextLink()) return; // Single-page collection

    injectStyles();

    observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) loadNext(); },
      { rootMargin: SCROLL_OFFSET }
    );

    attachSentinel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();